import { render, staticRenderFns } from "./ChartOfAccountsIndex.vue?vue&type=template&id=130b61e6"
import script from "./ChartOfAccountsIndex.vue?vue&type=script&lang=js"
export * from "./ChartOfAccountsIndex.vue?vue&type=script&lang=js"
import style0 from "./ChartOfAccountsIndex.vue?vue&type=style&index=0&id=130b61e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports